export const ACTIVITY_DEFAULT_ORDERING =
  '-event_date,activity_group_key,created_at';

type OrderField = { key: string; desc: boolean };

function parseOrderingFields(ordering: string): OrderField[] {
  return ordering.split(',').map((part) => {
    const desc = part.startsWith('-');
    return { key: desc ? part.slice(1) : part, desc };
  });
}

function getSortValue(
  item: object,
  key: string,
): string | number | null | undefined {
  const record = item as Record<string, unknown>;
  if (key === 'activity_group_key') {
    return (
      (record.payment_ref as string | null) ||
      (record.advance_id as string | null) ||
      (record.transaction_id as string) ||
      (record.uuid as string) ||
      ''
    );
  }
  if (key === 'created_at') {
    return (
      (record.created_at as string | null) || (record.uuid as string) || ''
    );
  }
  return record[key] as string | number | null | undefined;
}

function compareValues(
  aVal: string | number | null | undefined,
  bVal: string | number | null | undefined,
  desc: boolean,
): number {
  if (aVal == null) return 1;
  if (bVal == null) return -1;

  let cmp = 0;
  if (typeof aVal === 'string' && typeof bVal === 'string') {
    cmp = aVal.localeCompare(bVal);
  } else if (typeof aVal === 'number' && typeof bVal === 'number') {
    cmp = aVal - bVal;
  }
  return desc ? -cmp : cmp;
}

export function applyActivityOrdering<T extends object>(
  items: T[],
  ordering: string,
): T[] {
  const fields = parseOrderingFields(ordering || ACTIVITY_DEFAULT_ORDERING);
  return [...items].sort((a, b) => {
    for (const { key, desc } of fields) {
      const cmp = compareValues(
        getSortValue(a, key),
        getSortValue(b, key),
        desc,
      );
      if (cmp !== 0) return cmp;
    }
    return 0;
  });
}
